import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ACTION_MAP = {
  'form.submission.created':   { label: 'Submission aangemaakt',    icon: '+', color: '#3b82f6' },
  'form.submission.updated':   { label: 'Concept aangepast',        icon: '✎', color: '#6b7280' },
  'form.submission.submitted': { label: 'Ingediend',                icon: '✓', color: '#10b981' },
  'form.submission.deleted':   { label: 'Verwijderd',               icon: '×', color: '#dc2626' },
  'form.submission.emailed':   { label: 'Per email verstuurd',      icon: '✉', color: '#8b5cf6' },
  'form.quicksign.created':    { label: 'Quick-Sign aangemaakt',    icon: '⚡', color: '#3b82f6' },
  'form.signer.signed':        { label: 'Getekend',                 icon: '✍', color: '#10b981' },
  'form.signer.refused':       { label: 'Geweigerd',                icon: '✗', color: '#dc2626' },
  'form.workflow.completed':   { label: 'Workflow compleet',        icon: '★', color: '#059669' },
  'form.mail.opened':          { label: 'Email geopend (pixel)',    icon: '📨', color: '#8b5cf6' },
  'form.mail.clicked':         { label: 'Knop in email geklikt',    icon: '🖱️', color: '#7c3aed' },
  'form.signer.link_opened':   { label: 'Magic-link geopend',       icon: '🔗', color: '#3b82f6' },
  'form.signer.pdf_viewed':    { label: 'PDF bekeken (signer)',     icon: '👁', color: '#06b6d4' },
  'form.pdf.downloaded':       { label: 'PDF gedownload',           icon: '⬇', color: '#6b7280' },
};

// Parse user-agent naar mens-leesbare beschrijving
function parseUA(ua) {
  if (!ua) return { device: 'Onbekend', browser: '' };
  const isAndroid = /Android/i.test(ua);
  const isIPhone = /iPhone|iPad|iPod/i.test(ua);
  const isMac = /Macintosh/i.test(ua);
  const isWin = /Windows/i.test(ua);
  const isLinux = /Linux/i.test(ua) && !isAndroid;

  let device = 'Onbekend apparaat';
  if (isAndroid) device = '📱 Android telefoon';
  else if (isIPhone) device = '📱 iPhone / iPad';
  else if (isMac) device = '💻 Mac';
  else if (isWin) device = '💻 Windows';
  else if (isLinux) device = '💻 Linux';

  let browser = '';
  if (/EdgA|Edg\//i.test(ua)) browser = 'Edge';
  else if (/Firefox/i.test(ua)) browser = 'Firefox';
  else if (/Chrome/i.test(ua) && !/EdgA|Edg/i.test(ua)) browser = 'Chrome';
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = 'Safari';

  return { device, browser };
}

function fmtTime(ts) {
  return new Date(ts).toLocaleString('nl-NL', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
}

export default function AuditModal({ submissionId, onClose }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/audit/by-target/form_submission/${submissionId}`)
      .then(r => setEvents(r.data.events || []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [submissionId]);

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20, fontFamily: 'system-ui, sans-serif'
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'white', borderRadius: 12, maxWidth: 720, width: '100%',
        maxHeight: '85vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{
          padding: '16px 24px', borderBottom: '1px solid #e2e8f0',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#1e293b' }}>
              📋 Audit Trail · Submission #{submissionId}
            </div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
              Volledige forensische geschiedenis (IP + apparaat per actie)
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'transparent', border: 'none', fontSize: 24, cursor: 'pointer',
            color: '#64748b', padding: 4, lineHeight: 1
          }}>×</button>
        </div>

        {/* Body */}
        <div style={{ padding: 24, overflowY: 'auto', flex: 1 }}>
          {loading && <div style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>Laden…</div>}

          {!loading && events.length === 0 && (
            <div style={{ color: '#64748b', textAlign: 'center', padding: 40 }}>
              Geen audit events gevonden voor deze submission.
            </div>
          )}

          {!loading && events.length > 0 && (
            <div style={{ position: 'relative' }}>
              {/* Tijdlijn-lijn */}
              <div style={{
                position: 'absolute', left: 16, top: 8, bottom: 8,
                width: 2, background: '#e2e8f0'
              }} />

              {events.map((e, i) => {
                const meta = ACTION_MAP[e.action] || { label: e.action, icon: '•', color: '#64748b' };
                const ua = parseUA(e.user_agent);
                const details = e.details ? (typeof e.details === 'string' ? JSON.parse(e.details) : e.details) : {};

                return (
                  <div key={e.id} style={{
                    position: 'relative', paddingLeft: 50, marginBottom: 18,
                    paddingBottom: i === events.length - 1 ? 0 : 4
                  }}>
                    {/* Bolletje op timeline */}
                    <div style={{
                      position: 'absolute', left: 4, top: 2,
                      width: 26, height: 26, borderRadius: '50%',
                      background: meta.color, color: 'white',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 13, fontWeight: 700, boxShadow: '0 0 0 3px white'
                    }}>{meta.icon}</div>

                    {/* Card */}
                    <div style={{
                      background: '#f8fafc', border: '1px solid #e2e8f0',
                      borderRadius: 8, padding: '10px 14px'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                        <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 14 }}>
                          {meta.label}
                          {details.signer_naam && <span style={{ color: '#64748b', fontWeight: 400 }}> · door {details.signer_naam}</span>}
                          {e.actor_naam && !details.signer_naam && <span style={{ color: '#64748b', fontWeight: 400 }}> · door {e.actor_naam}</span>}
                        </div>
                        <div style={{ fontSize: 12, color: '#64748b', fontFamily: 'monospace' }}>
                          {fmtTime(e.created_at)}
                        </div>
                      </div>

                      {/* IP + Apparaat */}
                      <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 14, fontSize: 12, color: '#475569' }}>
                        {e.ip_address && (
                          <div>📍 <span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{e.ip_address}</span>
                            {e.geo && e.geo.country && (
                              <span style={{ color: '#64748b', marginLeft: 6 }}>
                                · {[e.geo.city, e.geo.country].filter(Boolean).join(', ')}
                                {e.geo.isp && <span style={{ opacity: 0.7 }}> ({e.geo.isp})</span>}
                              </span>
                            )}
                          </div>
                        )}
                        {ua.device !== 'Onbekend apparaat' && (
                          <div>{ua.device} {ua.browser && <span style={{ color: '#64748b' }}>· {ua.browser}</span>}</div>
                        )}
                      </div>

                      {/* Details (bij quick-sign created) */}
                      {details.aantal_signers && (
                        <div style={{ marginTop: 6, fontSize: 12, color: '#64748b' }}>
                          {details.aantal_signers} ondertekenaar{details.aantal_signers > 1 ? 's' : ''} · {details.mails_verzonden} mail(s) verstuurd
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '12px 24px', borderTop: '1px solid #e2e8f0',
          background: '#f8fafc', fontSize: 11, color: '#64748b', textAlign: 'center'
        }}>
          Deze audit trail is opgeslagen in een onveranderlijke database log.
        </div>
      </div>
    </div>
  );
}
